import React from 'react'
import ListingForm from './listingForm'
import { Row, Col } from 'react-bootstrap'
import BackButton from '../../common/buttons/backButton'
import { Item } from '../../../models/Item'
import { DeliveryRegion } from '../../../config/enums'

const VendorAddListing = () => {
  const initialValues: Item = {
    id: '',
    price: 0,
    thumbImageUrl: '',
    categoryIds: [],
    variants: [{ price: 0, description: '' }],
    options: ['price', 'description'],
    title: '',
    description: '',
    isActive: true,
    giftBundleId: '',
    installmentOptions: [{ month3: 0, month6: 0 }],
    deliveryOptions: [
      {
        region: DeliveryRegion.any,
        courier: '',
        minDays: 0,
        maxDays: 0,
        fee: 0
      }
    ],
    images: []
  }
  return (
    <>
      <Row>
        <Col className="pb-5" data-testid="backbutton">
          <h1 className="largeTitle">
            <div className="d-none d-sm-none d-md-none d-lg-inline">
              <BackButton rootPaths={['/']} size={35} />
            </div>
            Add a listing
          </h1>
        </Col>
      </Row>
      <Row>
        <Col xl="8" className="mx-auto">
          <ListingForm isEditing={false} initialValues={initialValues} />
        </Col>
      </Row>
    </>
  )
}

export default VendorAddListing
